/* */
const config_london = {
    s3: {
        REGION: 'eu-west-2',
        BUCKET: "prosanelin"
    },
    apiGateway: {
        REGION: 'eu-west-2',
        URL: "https://acupkaesed.execute-api.eu-west-2.amazonaws.com/prod"
    },
    cognito: {
        REGION: 'eu-west-2',
        USER_POOL_ID: "eu-west-2_a12WYMipf",
        APP_CLIENT_ID: "panevl2g4l5iq66djtf1rlikg",
        IDENTITY_POOL_ID: "eu-west-2:1f226523-e243-4927-8473-d572ad3d8eca"
    },
    PROS_S3_URL: 'https://share.prodect.fi/',
    PROS_HTML_PATH: 'https://share.prodect.fi/html/'
};
/* */

const config_stockholm = {
    s3: {
        REGION: 'eu-north-1',
        BUCKET: "media.prodect.fi"
    },
    apiGateway: {
        REGION: 'eu-north-1',
        URL: "https://ro9yvsgz6b.execute-api.eu-north-1.amazonaws.com/prod"
    },
    cognito: {
        REGION: 'eu-north-1',
        USER_POOL_ID: "eu-north-1_BqYlkSWiy",
        APP_CLIENT_ID: "6o23ulheoojosgso3jkvj8k3vl",
        IDENTITY_POOL_ID: "eu-north-1:bbca54d6-40e3-4b23-a65c-d40e1bad8563"
    },
    PROS_S3_URL: 'https://media.prodect.fi/',
    PROS_HTML_PATH: 'https://media.prodect.fi/html/'
};

const config_frankfurt = {
    s3: {
        REGION: 'eu-central-1',
        BUCKET: "test.prodect.fi"
    },
    apiGateway: {
        REGION: 'eu-central-1',
        URL: "https://qe2u3d7vb5.execute-api.eu-central-1.amazonaws.com/prod"
    },
    cognito: {
        REGION: 'eu-north-1',
        USER_POOL_ID: "eu-north-1_BqYlkSWiy",
        APP_CLIENT_ID: "6o23ulheoojosgso3jkvj8k3vl",
        IDENTITY_POOL_ID: "eu-north-1:bbca54d6-40e3-4b23-a65c-d40e1bad8563"
    },
    PROS_S3_URL: 'https://test.prodect.fi/',
    PROS_HTML_PATH: 'https://test.prodect.fi/html/'
};

// ======================== Set version and select test or production server ======================
// Build scripts to deploy:
//      Alpha     ./update-webui.sh --alpha         used for testing a new feature typically using test DB
//      Beta      ./update-webui.sh --beta          used to test new release
//      Production    ./update-webui.sh --prod      deploy a new release

// Select one of the following lines when build to deploy
const VERS_DETAIL =
//    '.1-debug local';         export const USE_PRODUCTION_SERVER = false; export const USE_DEVELOPMENT_FEATURES = true;
//  '.1-Alpha-4, 12.04.2024';   export const USE_PRODUCTION_SERVER = false; export const USE_DEVELOPMENT_FEATURES = true;
//  '.1-Beta-4, 12.04.2024';    export const USE_PRODUCTION_SERVER = true;  export const USE_DEVELOPMENT_FEATURES = false;
  '.1-4, 12.04.2024';         export const USE_PRODUCTION_SERVER = true;  export const USE_DEVELOPMENT_FEATURES = false;


// NOTE: when main version is changed should update "what is new in this version" into prodect help pages
export const PRODECT_SW_VERSION = "3.0"
export const PRODECT_SW_FULL_VERSION = PRODECT_SW_VERSION + VERS_DETAIL
export const VERS_STRING = 'Versio: ' + PRODECT_SW_FULL_VERSION

// ==================================================================================================

export const MAX_UPLOAD_FILE_SIZE = (24*1024*1024)

// Set false to test using London server, true to normal / Frankfurt:
const USE_FRANKFURT_AS_TEST_SERVER = true
const TEST_SERVER_CONFIG = USE_FRANKFURT_AS_TEST_SERVER ? config_frankfurt : config_london

const config = USE_PRODUCTION_SERVER ? config_stockholm : TEST_SERVER_CONFIG;

export const PROS_S3_URL = config.PROS_S3_URL;
export const PROS_HTML_PATH = config.PROS_HTML_PATH;


export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: MAX_UPLOAD_FILE_SIZE,
    ...config
};
